import { paths } from '~/__generated__/botco-api-schema';
import { ExtractOkResponseFromPath } from '~/types/open-api-helpers';

import { axiosClient } from '../axiosClient';

type PathUrl = paths['/instastack/document/upload/']['get'];
type Response = ExtractOkResponseFromPath<PathUrl>;

export const getInstaStackDocuments = () => {
  return axiosClient.get<Response>('/instastack/document/upload');
};
